import { useRefcodeLookup } from "../hooks/useRefcodeLookup";
import { WalletLink } from "./WalletLink";

interface ReferredByCardProps {
  refcode: string;
}

export function ReferredByCard({ refcode }: ReferredByCardProps) {
  const { data, isLoading, error } = useRefcodeLookup(refcode);

  if (isLoading) {
    return (
      <div className="flex items-center gap-2 text-gray-400">
        <span>Referred by</span>
        <span>Loading…</span>
      </div>
    );
  }

  if (error || !data?.data) {
    return (
      <div className="flex items-center gap-2">
        <span className="text-gray-400">Referred by</span>
        <span className="font-mono text-gray-200">{refcode}</span>
        <span className="text-gray-500 text-sm">(unknown wallet)</span>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2">
      <span className="text-gray-400">Referred by</span>
      <WalletLink address={data.data.walletAddress} />
      <span className="text-gray-500 text-sm font-mono">{refcode}</span>
    </div>
  );
}
